import { IEmailTemplate, IEmailTemplateVm } from "../../../models/response/email/IEmailTemplate";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from '../IGenericActionType';

export const eEmailTemplateDefine = {
    LOAD_START: undefined,
    LOAD_SUCCCES: [] as IEmailTemplateVm[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IEmailTemplate | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IEmailTemplate,
    SAVE_SUCCESS: {} as IEmailTemplate,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
}
export const eEmailTemplateActionTypeIds = generateActionTypeIds(eEmailTemplateDefine, "EMAIL_TEMPLATE")
export type IEmailTemplateActionTypes = IGenericActionType<typeof eEmailTemplateDefine, "EMAIL_TEMPLATE">